import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
`;

export const ContainerCustomFilter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const UfCustomFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AlignTitleColumn = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
